import gql from 'graphql-tag';

export const EDIT_PIXEL_APP_MUTATION = gql`
  mutation EditPixelTrackingAppMutation(
    $id: ID!
    $timezone: String!
    $pageUniquePart: String!
    $facebookPixelId: String!
    $estimatedMonthlyTraffic: String!
    $trafficEnabled: Boolean!
  ) {
    editPixelTrackingApp(
      id: $id
      timezone: $timezone
      pageUniquePart: $pageUniquePart
      facebookPixelId: $facebookPixelId
      estimatedMonthlyTraffic: $estimatedMonthlyTraffic
      trafficEnabled: $trafficEnabled
    ) {
      errors
    }
  }
`;
